'use client';

import { useBannerAdOpen } from '@wt/game/providers/bannerAdOpen/BannerAdOpenProvider';
import { useUserProvider } from '@wt/game/providers/user/UserProvider';
import { BackButton } from '@wt/shared/components/BackButton';
import { redirect } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import { GameForm } from '../../_components/GameForm/GameForm';
import { GameFormProvider } from '../../_components/GameForm/GameFormProvider';

export const NewGameContent = () => {
  const { loggedIn } = useUserProvider();
  const { adOpen } = useBannerAdOpen();

  useEffect(() => {
    if (!loggedIn) {
      localStorage.setItem('post-login-location', window.location.pathname);
      redirect('/login');
    }
  }, [loggedIn]);

  const top = useMemo(() => {
    return adOpen ? 'top-[103px] lg:top-[165px]' : 'top-[57px] lg:top-[79px]';
  }, [adOpen]);

  return (
    <div className="mb-5 flex w-full flex-col items-center justify-center px-4">
      <div className="flex w-full flex-col items-center gap-3 md:max-w-[650px]">
        <div
          className={`sticky ${top} z-30 flex w-full bg-base-100 pt-3 md:pt-5`}
        >
          <div className="relative mb-2 flex w-full items-center justify-center">
            <BackButton />
            <div className="w-full text-center text-xl md:text-2xl">
              New game
            </div>
          </div>
        </div>
        <GameFormProvider>
          <GameForm />
        </GameFormProvider>
      </div>
    </div>
  );
};
